import { ValidationErrorResponseData } from 'remix-validated-form';

export enum SystemRoles {
  Admin = 'admin',
  Seller = 'seller',
  User = 'user',
}

export enum AuctionType {
  TIME2LIVE = 'time2live',
  TIMEONLINE = 'timeonline',
  LIVEONLY = 'liveonly',
}

export enum AuctionPropertyType {
  NON_PROPERTY = 'non_property',
  OWNER_PROPERTY = 'owner_property',
  BANK_PROPERTY = 'bank_property',
}

export enum AuctionStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export enum AuctionRegistrationStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export enum PropertyType {
  APARTMENT = 'apartment',
  BUNGALOW = 'bungalow',
  CONDOMINIUM = 'condominium',
  FACTORY = 'factory',
  FLAT = 'flat',
  SEMI_DETACHED = 'semi_detached',
  SHOP_HOUSE = 'shop_house',
  SHOP_LOT = 'shop_lot',
  TERRACE = 'terrace',
  OTHERS = 'others',
}

export enum PropertyTenure {
  FREEHOLD = 'freehold',
  LEASEHOLD = 'leasehold',
  NOT_STATED = 'not-stated',
}

export enum PropertySize {
  LAND_AREA = 'land_area',
  BUILT_UP_AREA = 'built_up_area',
}

export enum InvoiceStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
}

export enum PaymentType {
  MANUAL = 'manual',
  ONLINE = 'online',
}

export interface FetcherData {
  status: string;
  action?: string;
  error?: string;
}

export type ActionData = { status: 'success' } | { status: 'error'; message: string } | ValidationErrorResponseData;

export type ActionDataWithDocument =
  | { type: 'document'; document: string }
  | { type: 'success'; status: 'success'; message?: string }
  | { type: 'error'; status: 'error'; error: { message: string } };

export enum CategoryIdToName {
  '017214cb-2972-44fc-ba20-cf93d854ee53' = 'Collectibles',
  '8b5d0e8c-00ae-4d19-bd06-e1a5114e0ae0' = 'Antiques',
  'a9dc7fa2-cbe1-4541-8bdb-8374df8e7e16' = 'Jewellery',
  'de4af6c9-48a5-4ddb-802e-e2c8b600624b' = 'Coins',
  '73f45605-9730-430e-a0ba-a145f6844d14' = 'Property',
  'db072906-0d93-4c53-ba6e-98ba90c23067' = 'Others',
  '849b1f9e-84f9-4bb8-83c6-68b5727f31dd' = 'Art',
  'b1a0d1af-400f-47d9-a797-fb59b72df46a' = 'Stamps',
  '69ca2338-5404-44b8-80e4-f5021624c6ee' = 'Banknotes',
}

export interface Bid {
  auctionId: string;
  createdAt: string;
  deletedAt: string | null;
  id: string;
  increments: number;
  priceFrom: number;
  priceTo: number;
  updatedAt: string;
}

export interface CurrentBid {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  type: string | null;
  userId: string;
  user: any;
  amount: number;
  productId: string;
  auctionId: string;
}

export interface UploadedDocument {
  src: string;
  name: string;
  size: number;
  type: string;
  deletedAt?: string | null;
}

export interface CloudflareStreamDetails {
  uid: string;
  webRTC: {
    url: string;
  };
}

export interface BackendStreamDetails {
  livestreamUid: string;
  webRTCUrl: string | null;
}

export type StreamDetails = BackendStreamDetails | CloudflareStreamDetails | null;

export enum PusherChannel {
  BEST2BID_AUCTIONS = 'best2bid-auctions',
  LIVE_AUCTION = 'live-auction',
}

export enum PusherEvent {
  NEW_BID = 'new-bid',
  LOCK_BID = 'lock-bid',
  UNLOCK_BID = 'unlock-bid',
  OPEN_BID = 'open-bid',
  PAUSE_AUCTION = 'pause-auction',
  RESUME_AUCTION = 'resume-auction',
  UNSOLD_AUCTION = 'unsold-auction',
  END_AUCTION = 'end-auction',
  RESET_WARNING = 'reset-warning',
  FAIR_WARNING = 'fair-warning',
  FINAL_WARNING = 'final-warning',
  NEW_MESSAGE = 'new-message',
  SKIP_TO_LOT = 'skip-to-lot',
  LOT_SOLD = 'lot-sold',
}

export enum ActivityLogType {
  BID_NEW = 'bid-new',
  BID_OPEN = 'bid-open',
  BID_END = 'bid-end',
  BID_LOCK = 'bid-lock',
  BID_UNLOCK = 'bid_unlock',
  BID_CLOSE = 'bid_close',
  LOT_SKIP = 'lot-skip',
  LOT_SOLD = 'lot-sold',
  LOT_RESET = 'lot-reset',
  AUCTION_PAUSE = 'auction-pause',
  AUCTION_RESUME = 'auction-resume',
  AUCTION_UNSOLD = 'auction-unsold',
  MESSAGE_NEW = 'message-new',
  FAIR_WARNING = 'fair-warning',
  FINAL_WARNING = 'final-warning',
}
